import { Button, DataSource, Label, Layout, Table } from "@mcleod/components";

export abstract class AutogenLayoutMobileCommExAppSelectionList extends Layout {
    buttonEdit: Button;
    labelExternalAppControlSelections: Label;
    sourceExAppSelections: DataSource;
    tableSelections: Table;
}
